import { Fragment } from "react";
import { Check } from "react-feather";

const STEPS = ["Data Diri", "Pilih Tiket", "Selesai"];

const CheckoutSteps = ({ current }) => {
  return (
    <div className="stepper">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const state = n < current ? "done" : n === current ? "active" : "";
        return (
          <Fragment key={n}>
            <div className={`step ${state}`}>
              <div className="step-dot">
                {n < current ? <Check size={15} /> : n}
              </div>
              <span className="step-label">{label}</span>
            </div>
            {n < STEPS.length && (
              <div className={`step-line ${n < current ? "done" : ""}`} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default CheckoutSteps;
